import React from 'react';

import { Checkbox } from '@ontruck/orc';
import { StyledFilter } from './styled';

const t = {
  label: 'FTB',
};

const FTBFilter = ({ value, stylingProps, onChange }) => {
  const handleChange = (e, { value }) => {
    onChange(value);
  };

  return (
    <StyledFilter {...stylingProps}>
      <Checkbox
        name="ftb"
        girded
        contracted
        label={t.label}
        size="M"
        checked={value}
        onChange={handleChange}
      />
    </StyledFilter>
  );
};

FTBFilter.filterName = 'FTBFilter';

export default FTBFilter;
